export function payoutsSearchData(vm) {
	return [
		{
			title: "",
			type: "1",
			data: [
				{
					type: "date",
					arr: [],
					key: ["start_pay_time", "end_pay_time"],
					placeholder: "打款时间",
				},
				{
					type: "date",
					arr: [],
					key: ["start_time", "end_time"],
					placeholder: "申请时间",
				},
			],
		},
		{
			title: '',
			type: '2',
			data: [
				{
					type: 'text',
					key: 'pay_name',
					placeholder: '支付宝姓名'
				},
				{
					type: 'text',
					key: 'pay_code',
					placeholder: '支付宝账号'
				},
				{
					type: 'text',
					key: 'nickname',
					placeholder: '用户昵称'
				},
				{
					type: 'text',
					key: 'username',
					placeholder: '用户名'
				},
				{
					type: 'select',
					key: 'pay_type',
					option: [
						{
							id: '1',
							title: '手动结款'
						},
						{
							id: '2',
							title: '公账打款'
						}
					],
					placeholder: '结款方式',
					onChange: () => { }
				},
				{
					type: 'select',
					key: 'payouts_type',
					option: [
						{
							id: '0',
							title: '支付宝'
						},
						{
							id: '1',
							title: '微信'
						}
					],
					placeholder: '申请结账类型',
					onChange: () => { }
				},
				{
					type: 'select',
					key: 'is_finish',
					option: [
						{
							id: '0',
							title: '未结款'
						},
						{
							id: '1',
							title: '已结款'
						},
						{
							id: '2',
							title: '已拒绝'
						}
					],
					placeholder: '结款状态',
					onChange: () => { }
				},
			]
		}
	];
}
export function billSearchData(vm) {
	return [
		{
			title: "",
			type: "1",
			data: [

				{
					type: "date",
					arr: [],
					key: ["start_time", "end_time"],
					placeholder: "创建时间",
				},
			],
		},
		{
			title: '',
			type: '2',
			data: [

				{
					type: 'select',
					key: 'ad_name',
					option: [
						{
							id: '快手',
							title: '快手'
						},
						{
							id: '百度',
							title: '百度'
						},
						{
							id: '腾讯',
							title: '腾讯'
						},
						{
							id: '穿山甲',
							title: '穿山甲'
						}
					],
					placeholder: '广告商',
					onChange: () => { }
				},
				{
					type: 'select',
					key: 'type',
					option: [
						{
							id: 'decrease',
							title: '提现'
						},
						{
							id: 'increase',
							title: '收益'
						}
					],
					placeholder: '类型',
					onChange: () => { }
				},
				{
					type: 'select',
					key: 'is_app',
					option: [
						{
							id: '1',
							title: '平台收益'
						},
						{
							id: '0',
							title: '用户收益'
						}
					],
					placeholder: '收益类型',
					onChange: () => { }
				},

			]
		}
	];
}
export function accessadSearchData(vm) {
	return [
		{
			title: "",
			type: "1",
			data: [

				{
					type: "date",
					arr: [],
					key: ["start_time", "end_time"],
					placeholder: "回调时间",
				},
			],
		},
		{
			title: '',
			type: '2',
			data: [
				{
					type: 'select',
					key: 'name',
					option: [

						{ id: '未知', title: '未知' },
						{ id: '腾讯广告(优量汇)', title: '腾讯广告(优量汇)' },
						{ id: '穿山甲（CSJ）', title: '穿山甲（CSJ）' },
						{ id: '百度（Baidu）', title: '百度（Baidu）' },
						{ id: '快手', title: '快手' },
						{ id: 'Admob', title: 'Admob' },
						{ id: 'Mintegral', title: 'Mintegral' },
						{ id: 'Tapjoy', title: 'Tapjoy' },
						{ id: 'ironSource', title: 'ironSource' },
						{ id: 'Unity Ads', title: 'Unity Ads' },
						{ id: 'Liftoff(Vungle)', title: 'Liftoff(Vungle)' },
						{ id: 'Bigo', title: 'Bigo' },
						{ id: 'Yandex', title: 'Yandex' },
						{ id: 'TapTap', title: 'TapTap' },
						{ id: 'Digital Turbine(Fyber)', title: 'Digital Turbine(Fyber)' },
						{ id: 'myTarget', title: 'myTarget' },
						{ id: 'Sigmob', title: 'Sigmob' },
						{ id: 'Pangle', title: 'Pangle' },
						{ id: '华为广告（Huawei）', title: '华为广告（Huawei）' },
						{ id: 'Nend', title: 'Nend' },
						{ id: 'Maio', title: 'Maio' },
						{ id: 'Start.io', title: 'Start.io' },
						{ id: 'Google Ad Manger', title: 'Google Ad Manger' },
						{ id: 'Ogury', title: 'Ogury' },
						{ id: 'Kidoz', title: 'Kidoz' },
						{ id: 'A4G', title: 'A4G' },
						{ id: '米盟', title: '米盟' },
						{ id: 'ReklamUp', title: 'ReklamUp' },
						{ id: 'Verve', title: 'Verve' },
						{ id: 'TopOn Adx', title: 'TopOn Adx' },
						{ id: '趣盟', title: '趣盟' },
						{ id: 'vivo广告联盟', title: 'vivo广告联盟' },
						{ id: 'OPPO广告联盟', title: 'OPPO广告联盟' }

					],
					placeholder: '广告商',
					onChange: () => { }
				},
				{
					type: 'select',
					key: 'accounting',
					option: [
						{
							id: '0',
							title: '否'
						},
						{
							id: '1',
							title: '是'
						}
					],
					placeholder: '是否分佣完成',
					onChange: () => { }
				},
				{
					type: 'select',
					key: 'app_id',
					option: vm.$store.state.appList,
					placeholder: 'APP名称',
					onChange: () => { }
				},
				{
					type: 'text',
					key: 'mediation_rit',
					placeholder: '代码位'
				},
				{
					type: 'text',
					key: 'username',
					placeholder: '用户名称'
				},
				{
					type: 'text',
					key: 'nickname',
					placeholder: '用户昵称'
				},
			]
		}
	];
}
export function adnSearchData(vm) {
	return [
		{
			title: '',
			type: '2',
			data: [
				{
					type: 'text',
					key: 'app_name',
					placeholder: '请输入APP名称'
				},
				{
					type: 'select',
					key: 'is_open',
					option: [
						{
							id: '0',
							title: '否'
						},
						{
							id: '1',
							title: '是'
						}
					],
					placeholder: '是否开站',
					onChange: () => { }
				}
			]
		}
	];
}
export function appSearchData(vm) {
	return [
		{
			title: '',
			type: '2',
			data: [
				{
					type: 'text',
					key: 'app_name',
					placeholder: '请输入APP名称'
				},
				{
					type: 'select',
					key: 'is_open',
					option: [
						{
							id: '0',
							title: '否'
						},
						{
							id: '1',
							title: '是'
						}
					],
					placeholder: '是否开站',
					onChange: () => { }
				}
			]
		}
	];
}
export function channelSearchData(vm) {
	return [
		{
			title: "",
			type: "2",
			data: [
				{
					type: "text",
					key: "app_name",
					placeholder: "搜索 APP 名称"
				},
				{
					type: "text",
					key: "nickname",
					placeholder: "搜索渠道名称"
				},
				{
					type: "select",
					key: "is_open",
					option: [
						{
							id: "1",
							title: "开启"
						},
						{
							id: "0",
							title: "关闭"
						}
					],
					placeholder: "渠道状态",
					onChange: () => { }
				}
			]
		}
	];
}
export function userSearchData(vm) {
	return [
		{
			title: "",
			type: "1",
			data: [
				{
					type: "date",
					arr: [],
					key: ["last_time_start", "last_time_end"],
					placeholder: "最后登入时间",
				},
				{
					type: "date",
					arr: [],
					key: ["start_time", "end_time"],
					placeholder: "注册时间",
				},
			],
		},
		{
			title: '',
			type: '2',
			data: [
				{
					type: 'text',
					key: 'nickname',
					placeholder: '请输入用户昵称'
				},
				{
					type: 'text',
					key: 'username',
					placeholder: '请输入用户名'
				},
				{
					type: 'text',
					key: 'recommend_number',
					placeholder: '直推比例'
				},
				{
					type: 'select',
					key: 'is_banned',
					option: [
						{
							id: '0',
							title: '否'
						},
						{
							id: '1',
							title: '是'
						}
					],
					placeholder: '是否异常',
					onChange: () => { }
				},
				{
					type: 'select',
					key: 'online',
					option: [

						{
							id: '1',
							title: '在线'
						}
					],
					placeholder: '是否在线',
					onChange: () => { }
				},
				{
					type: 'select',
					key: 'app_id',
					option: vm.$store.getters.getAppListGetter,
					placeholder: '所属app',
					onChange: () => { }
				}

			]
		}
	];
}
export function channelUserSearchData(vm) {
	return [
		{
			title: "",
			type: "1",
			data: [
				{
					type: "date",
					arr: [],
					key: ["start_time", "end_time"],
					placeholder: "注册时间",
				},
			],
		},
		{
			title: '',
			type: '2',
			data: [
				{
					type: 'text',
					key: 'nickname',
					placeholder: '请输入用户昵称'
				},
				{
					type: 'text',
					key: 'title',
					placeholder: '请输入用户名'
				},
				{
					type: 'text',
					key: 'id',
					placeholder: '请输入用户id'
				},
			]
		},

	];
}
export function userAdSearchData(vm) {
	return [
		{
			title: "",
			type: "1",
			data: [
				{
					type: "date",
					arr: [],
					key: ["start_time", "end_time"],
					placeholder: "注册时间",
				},
			],
		},
		{
			title: '',
			type: '2',
			data: [
				{
					type: 'text',
					key: 'nickname',
					placeholder: '请输入用户昵称'
				},
				{
					type: 'text',
					key: 'title',
					placeholder: '请输入用户名'
				},
				{
					type: 'text',
					key: 'id',
					placeholder: '请输入用户id'
				},
				{
					type: 'text',
					key: 'channel_id',
					placeholder: '渠道ID'
				},
				{
					type: 'select',
					key: 'app_id',
					option: vm.$store.getters.getAppListGetter,
					placeholder: '所属app',
					onChange: () => { }
				},
				{
					type: 'select',
					key: 'online',
					option: [
						{
							id: '1',
							title: '在线'
						},
						
					],
					placeholder: '是否在线',
					onChange: () => { }
				},
			]
		},

	];
}
